import React from "react";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";

import Header from "./components/Header";
//import Footer from '../components/footer';

import AssetDisplay from "./pages/AssetDisplay";
import NotFound from "./components/NotFound";
import HistoryDisplay from "./components/HistoryDisplay";
import useToken from "./useToken";

const App = () => {
  const { token } = useToken();
  const history = useHistory();

  if (!token) {
    history.push("/Login");
  }

  function PrivateRoute({ children, ...rest }) {
    const { token } = useToken();
    return (
      <Route
        {...rest}
        render={({ location }) =>
          token ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/Login",
                state: { from: location },
              }}
            />
          )
        }
      />
    );
  }

  return (
    <div id="main">
      <Switch>
        <Route exact path="/Login" component={Login} />
        <PrivateRoute path="/">
          <Header />
          <Route exact path="/" component={Home} />
          <Switch>
            <Route exact path="/asset/not-found" component={NotFound} />
            <Route exact path="/asset/:id" component={AssetDisplay} />
          </Switch>
          <Route exact path="/history" component={HistoryDisplay} />
        </PrivateRoute>
      </Switch>
      {/*Add Footer */}
    </div>
  );
};

export default App;
